/* Wrapped because a Capacitor plugin proxy answers `then`, so resolving a promise with it bare never settles. */
const loadPlugin = async (): Promise<{
  plugin: typeof import("@capacitor/status-bar").StatusBar;
  style: typeof import("@capacitor/status-bar").Style;
}> => {
  const { StatusBar, Style } = await import("@capacitor/status-bar");
  return { plugin: StatusBar, style: Style };
};

/* The plugin names a style for the background it sits on: `Style.Light` is dark text for a light theme. */
export const setNativeStatusBarStyle = async ({ isDark }: { isDark: boolean }): Promise<void> => {
  const { plugin, style } = await loadPlugin();
  await plugin.setStyle({ style: isDark ? style.Dark : style.Light });
};
